import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function CorporateFareIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12918_64123" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12918_64123)"><path d="M2 21V3H11.75V7.125H22V21H2ZM3.5 19.5H10.25V16.875H3.5V19.5ZM3.5 15.375H10.25V12.75H3.5V15.375ZM3.5 11.25H10.25V8.625H3.5V11.25ZM3.5 7.125H10.25V4.5H3.5V7.125ZM11.75 19.5H20.5V8.625H11.75V19.5ZM13.75 12.75V11.25H17.875V12.75H13.75ZM13.75 16.875V15.375H17.875V16.875H13.75Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}